import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  CollectionSyncLogsQuery,
  CollectionSyncLogsQueryResult,
} from "../../../generated/gql/graphql";

const GET_COLLECTION_SYNC_LOGS = gql`
  query GetCollectionSyncLogs(
    $collectionId: String!
    $query: CollectionSyncLogsQuery
  ) {
    collectionSyncLogs(collectionId: $collectionId, query: $query) {
      items {
        id
        status
        triggerType
        scheduledAt
        executedAt
        dateCreated
        dateUpdated
        triggeredBy
        triggeredByName
        startedBy
        canceledBy
        canceledByName
        errorLog
        assets {
          id
          name
          image
          addedBy
          addedByName
          addedAt
        }
      }
      limit
      offset
      page
      totalCount
    }
  }
`;

export default function useCollectionSyncLogs(
  collectionId: string,
  query?: CollectionSyncLogsQuery
): QueryResult<{ collectionSyncLogs: CollectionSyncLogsQueryResult }> {
  return useQuery(GET_COLLECTION_SYNC_LOGS, {
    variables: {
      collectionId,
      query,
    },
    fetchPolicy: "cache-and-network",
  });
}
